// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderOuterOutlinedSvg from "@fishx/icons-svg/es/asn/BorderOuterOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderOuterOutlinedSvg
  }));
};

BorderOuterOutlined.displayName = 'BorderOuterOutlined';
export default React.forwardRef(BorderOuterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderOuterOutlined.js
// module id = 2093
// module chunks = 0